// hooks/useTrackVisit.js
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useCallback } from 'react';
import { addVisitedItem } from '../redux/recentlyVisitedSlice';

export const useTrackVisit = (pageTitle = null) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // Automatically track page visits when component mounts
  useEffect(() => {
    if (pageTitle && location.pathname) {
      trackVisit(pageTitle, location.pathname);
    }
  }, [location.pathname, pageTitle]);

  const trackVisit = useCallback((title, path) => {
    // Only track if it's not the dashboard or main pages
    const excludedPaths = ['/', '/dashboard', '/login'];
    if (!excludedPaths.includes(path)) {
      dispatch(addVisitedItem({ 
        title, 
        path,
        // Include search params if they exist
        fullPath: location.search ? `${path}${location.search}` : path
      }));
    }
  }, [dispatch, location.search]);

  const navigateAndTrack = useCallback((path, title) => {
    if (title) {
      trackVisit(title, path);
    }
    navigate(path);
  }, [navigate, trackVisit]);

  return {
    trackVisit,
    navigateAndTrack
  };
};